module.exports = __webpack_public_path__ + "static/media/front_sided_edited1.b2e5ee09.png";